import { createRouter, createWebHistory } from 'vue-router'
import Step1 from '../views/Step1.vue'

const routes = [
  {
    path: '/',
    name: 'Step 1',
    component: Step1
  },
  {
    path: '/step-2',
    name: 'Step 2',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Step2.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
